import React from 'react'
import {
    StyledWardenParagraph,
    StyledWardenTitle,
    StyledWebLinkButton,
} from '..'
import {
    StyledActionWrapper,
    StyledContainer,
} from './components/CommonAccountDelete.styled'

export interface AccountDeletedProps {
    title: string | JSX.Element
    paragraph: string | JSX.Element
    backHomeButton: {
        show: boolean
        text: string
    }
}

export const AccountDeleted: React.FC<AccountDeletedProps> = ({
    title,
    paragraph,
    backHomeButton,
}: AccountDeletedProps) => {
    return (
        <StyledContainer>
            <StyledWardenTitle>{title}</StyledWardenTitle>
            <StyledWardenParagraph>{paragraph}</StyledWardenParagraph>
            {backHomeButton.show ? (
                <>
                    <StyledActionWrapper>
                        <StyledWebLinkButton to="/" forceInternalSSR>
                            {backHomeButton.text}
                        </StyledWebLinkButton>
                    </StyledActionWrapper>
                </>
            ) : null}
        </StyledContainer>
    )
}
